export default __webpack_public_path__ + "static/media/Hajo-am-Miscantes-076.f956227d.jpg";